import { ROUTE_TO_NEXT } from 'redux-router-kit';

import { readCookie } from '@zapier/cookies';
import { addTruthyParamsToUrl } from '@zapier/url-utils';

import { Account } from '@zapier/shared-entities';

const accountQueryParam = 'context';
const accountSwitcherUrlKey = 'accountSwitcherUrl';

const accountSwitcherMiddleware = store => next => action => {
  if (!action || action.type !== ROUTE_TO_NEXT) {
    return next(action);
  }

  const currentAccountId = parseInt(readCookie('currentAccountId'), 10);

  if (!currentAccountId) {
    return next(action);
  }

  const stateCurrentAccountId = Account.selectors.all.currentAccountId(
    store.getState()
  );

  if (stateCurrentAccountId) {
    if (stateCurrentAccountId !== currentAccountId) {
      // User must have switched accounts in a different tab for this session.
      store.dispatch(Account.actions.switchAccount(currentAccountId));
    }
  } else {
    // initalizeCurrentAccount() didn't run yet, this is a fresh page request.
    // We can't validate, nor need to refresh via switchAccount().
    // Just store it and initalizeCurrentAccount() will validate and fall back
    // to the primary account if it's not.
    store.dispatch(Account.actions.storeCurrentAccountId(currentAccountId));
  }

  return next(action);
};

export const attachAccountIdToUrl = (accountId, url) => {
  return addTruthyParamsToUrl(url, { [accountQueryParam]: accountId });
};

export const assignAccountSwitcherUrl = url => ({
  [accountSwitcherUrlKey]: url,
});

export default accountSwitcherMiddleware;
